import { apiClient } from './ApiClient';
import { API_ENDPOINTS } from '../../shared/constants';
import { ApiResponse, DriverApiData } from '../../shared/types';
import { Driver } from '../../domain/entities';

export class DriverApi {
    static async fetchByRegistrationAndClientId(
        registration: string,
        clientId: number,
        token: string
    ): Promise<Driver | null> {
        try {
            const response = await apiClient.get<ApiResponse<DriverApiData>>(
                API_ENDPOINTS.driver(registration, clientId),
                token
            );

            if (!response.success || !response.data) {
                return null;
            }

            return new Driver(
                response.data.id,
                response.data.nome,
                registration
            );
        } catch (error) {
            console.error('Error fetching driver:', error);
            return null;
        }
    }
}

